import {Component, EventEmitter, Input, Output} from '@angular/core';
import {defaultPage, IPage} from "../../../../../../base/models/pagination.model";
import {BaseComponent} from "../../../../../../base/components/base.component";
import {EventBusService} from "../../../../../../base/services/eventbus/event-bus.service";
import {ActivatedRoute, Router} from "@angular/router";
import {SubscriptionContainerService} from "../../../../../../base/services/subscription-container.service";
import {IParams} from "../../../../../../base/endpoints/iparams";

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent<T> extends BaseComponent {
  @Input() page: IPage<T> = defaultPage

  pageNumber: number = 0
  pageSize: number = 10

  @Output() onPageChanged: EventEmitter<IParams> = new EventEmitter()

  protected componentName(): string {
    return PaginationComponent.name
  }

  constructor(
    eventBus: EventBusService,
    router: Router,
    subContainer: SubscriptionContainerService,
    private activatedRoute: ActivatedRoute,
  ) {
    super(eventBus, router, subContainer)
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      let page = params['page']
      let size = params['size']
      this.pageNumber = parseInt(page == null ? this.page.number : page)
      this.pageSize = parseInt(size == null ? this.page.size : size)
      this.onPageChanged.emit(params)
    });
  }

  private processParams(data: object): IParams {
    let params: IParams = {}
    for (let entry of Object.entries(data)) {
      // console.log(entry[0] + entry[1])
        params[entry[0]] = entry[1]
    }
    return params
  }

  onPageSelected(page: number) {
    this.router.navigate(['.'], {
      relativeTo: this.activatedRoute,
      queryParams: {
        page: page,
        size: this.pageSize
      },
      queryParamsHandling: 'merge',
    }).then(r => {
    });
  }

  onNextClick() {
    this.router.navigate(['.'], {
      relativeTo: this.activatedRoute,
      queryParams: {
        page: this.pageNumber + 1,
        size: this.pageSize
      },
      queryParamsHandling: 'merge',
    }).then(r => {
    });
  }

  onPreviousClick() {
    this.router.navigate(['.'], {
      relativeTo: this.activatedRoute,
      queryParams: {
        page: this.pageNumber - 1,
        size: this.pageSize
      },
      queryParamsHandling: 'merge',
    }).then(r => {
    });
  }
}
